import { render, staticRenderFns } from "./CategoryHeading.vue?vue&type=template&id=348f3f32&scoped=true&"
import script from "./CategoryHeading.vue?vue&type=script&lang=ts&"
export * from "./CategoryHeading.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryHeading.vue?vue&type=style&index=0&id=348f3f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f3f32",
  null
  
)

export default component.exports